/* ============================================================
   Scroll reveal animations — see animations.css for usage.
   ============================================================ */
(function () {
  const root = document.documentElement;
  if (!root.classList.contains('animations-enabled')) return;

  const repeat = root.dataset.animationRepeat === 'true';
  const SELECTOR = [
    '.animate',
    '.animate-stagger',
    '.animations-all-sections #main-content > .shopify-section',
  ].join(',');

  function revealNow(element) {
    element.classList.add('is-revealed', 'is-animated');
  }

  function markAnimatedWhenDone(element) {
    if (repeat) return;

    const duration = parseFloat(getComputedStyle(root).getPropertyValue('--animation-duration')) || 700;
    const stagger = parseFloat(getComputedStyle(root).getPropertyValue('--animation-stagger')) || 0;
    const items = element.classList.contains('animate-stagger') ? element.querySelectorAll('.animate-item').length : 0;

    setTimeout(() => element.classList.add('is-animated'), duration + stagger * Math.min(items, 12) + 100);
  }

  function indexStaggerItems(container) {
    container.querySelectorAll('.animate-item').forEach((item, index) => {
      item.style.setProperty('--animate-index', Math.min(index, 12));
    });
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTOR).forEach(revealNow);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const element = entry.target;

        if (entry.isIntersecting) {
          element.classList.add('is-revealed');
          markAnimatedWhenDone(element);
          if (!repeat) observer.unobserve(element);
        } else if (repeat && entry.boundingClientRect.top > 0) {
          // Only reset when the element is below the viewport so it replays on scroll down
          element.classList.remove('is-revealed');
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  function init(scope) {
    const elements = [];
    if (scope.matches && scope.matches(SELECTOR)) elements.push(scope);
    scope.querySelectorAll(SELECTOR).forEach((element) => elements.push(element));

    elements.forEach((element) => {
      if (element.dataset.animateObserved === 'true') return;
      element.dataset.animateObserved = 'true';
      if (element.classList.contains('animate-stagger')) indexStaggerItems(element);
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    revealNow(event.target);
    event.target.querySelectorAll(SELECTOR).forEach(revealNow);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('.shopify-section');
    if (!section) return;
    revealNow(section);
    section.querySelectorAll(SELECTOR).forEach(revealNow);
  });
})();
